import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { observer } from "mobx-react";
import { Form, Table } from "react-bootstrap";

import { convertSecondsToTime, toastWithAsyncFetch } from "../../../utils/helper";
import { useAPI } from "../../../providers/ApiProvider";

export const TimelineForm = observer(
  forwardRef(({ currentLesson, videoTime }, ref) => {
    const api = useAPI();
    const timestampContentRef = useRef(null);

    useImperativeHandle(ref, () => ({
      getTimestampContent() {
        return timestampContentRef.current.value;
      },

      setTimestampContent(content) {
        timestampContentRef.current.value = content;
      },
    }));

    const createTimestampHandler = () => {
      if (!currentLesson.video) return;

      toastWithAsyncFetch(
        {
          loading: "Đang tạo timestamp...",
          success: "Thêm timestamp thành công",
          error: "Thêm timestamp thất bại!",
        },
        api.callApi.bind(null, "createTimeline", {
          params: { videoId: currentLesson.video.id },
          body: { checkpoint: videoTime, content: timestampContentRef.current?.value },
        }),
        (res) => {
          currentLesson.video.addTimeline(res.data.data.timeline);
          timestampContentRef.current.value = "";
        },
      );
    };

    const deleteTimestampHandler = (id) => {
      toastWithAsyncFetch(
        {
          loading: "Đang xoá timestamp...",
          success: "Xoá timestamp thành công",
          error: "Xoá timestamp thất bại!",
        },
        api.callApi.bind(null, "deleteTimeline", {
          params: { pk: id },
        }),
        (res) => currentLesson.video.deleteTimeline(id),
      );
    };

    return (
      currentLesson.video?.video_url && (
        <>
          <Form.Group className="mt-4">
            <Form.Label className="fw-bold">Timeline bài học</Form.Label>
            <div className="d-flex flex-column flex-lg-row">
              <div className="form-control d-flex flex-row justify-content-start align-items-center rounded-10 p-0 px-2">
                <div className="p-3" style={{ flexBasis: "100px" }}>
                  {convertSecondsToTime(videoTime)}
                </div>
                <span className="mx-1">-</span>
                <Form.Control
                  ref={timestampContentRef}
                  placeholder="Ví dụ: Thao tác cơ bản"
                  className="flex-grow-1 rounded-10 outline-0 border-0 p-3"
                />
              </div>
              <div
                role="button"
                className="add-timestamp-btn bg-gradient-orange text-nowrap rounded-10 mt-2 px-4 py-3 mt-lg-0 ms-lg-3"
                onClick={createTimestampHandler}
              >
                <i className="fa-duotone fa-list-timeline me-3" />
                Thêm timestamp
              </div>
            </div>
            <div className="fs-7 text-black-50 mt-2">
              Gợi ý: Phần này của bài học nói về điều gì
            </div>
          </Form.Group>

          {currentLesson.video.timelines?.length <= 0 ? (
            <div className="no-item rounded-10 text-black-50 mt-3">
              Bài học chưa có timestamp nào
            </div>
          ) : (
            <Table className="timestamp-list mt-3">
              <tbody>
                {currentLesson.video.timelines.map((timestamp) => (
                  <tr className="timestamp" key={timestamp.id}>
                    <td className="ps-0" style={{ width: "1%" }}>
                      <div
                        role="button"
                        className="time fw-bold text-center border p-1 px-3 rounded-10"
                      >
                        {convertSecondsToTime(timestamp.checkpoint)}
                      </div>
                    </td>
                    <td className="text">{timestamp.content}</td>
                    <td className="d-flex justify-content-end">
                      <div
                        role="button"
                        className="timestamp-action rounded p-2"
                        onClick={deleteTimestampHandler.bind(null, timestamp.id)}
                      >
                        <i className="fa-duotone fa-trash" />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </>
      )
    );
  }),
);
